import { FC } from 'react';
import { useHookstate } from '@hookstate/core';
import { CallBoard75 } from '../../components/CallBoard75';
import { CallBoard80 } from '../../components/CallBoard80';
import { CallBoard90 } from '../../components/CallBoard90';
import { CallBoard30 } from '../../components/CallBoard30';
import { useGameType } from '../../hooks/use-game-type';
import { calls, current, fireBallStatus } from '../../stores/backend';

const CALL_BOARD_COMPONENTS = {
    75: CallBoard75,
    80: CallBoard80,
    90: CallBoard90,
    30: CallBoard30,
};

export const CallBoardPanel: FC = () => {
    const $current = useHookstate(current);
    const $calls = useHookstate(calls);
    const $fireBallStatus = useHookstate(fireBallStatus);

    const gameType = useGameType($current);
    const called = $calls.value;

    const CallBoard = CALL_BOARD_COMPONENTS[gameType];

    return (
        <CallBoard
            called={called}
            fireBall={$current.fireball?.value}
            fireBallSnuffed={$fireBallStatus.value === 'snuffed'}
        />
    );
};
